"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildRequestFromAttribute = buildRequestFromAttribute;
exports.buildRequestFromAttributeAndSearchQuery = buildRequestFromAttributeAndSearchQuery;
exports.buildRequestFromCombinedSearchQuery = buildRequestFromCombinedSearchQuery;
exports.buildRequestFromSearchQuery = buildRequestFromSearchQuery;
exports.addAttributeToSearchQuery = addAttributeToSearchQuery;
exports.combineSearchQuery = combineSearchQuery;
exports.buildAttributeQuery = buildAttributeQuery;
exports.buildMultiFacet = buildMultiFacet;
const SearchEnums_1 = require("@rcsb/rcsb-api-tools/lib/RcsbSearch/Types/SearchEnums");
const lodash_1 = require("lodash");
function buildRequestFromAttribute(searchAttribute, returnType, requestOptions) {
    return {
        query: buildAttributeQuery(searchAttribute),
        return_type: returnType,
        request_options: requestOptions
    };
}
function buildRequestFromAttributeAndSearchQuery(searchAttribute, searchQuery, returnType, logicalOperator = SearchEnums_1.LogicalOperator.And, requestOptions) {
    return {
        query: addAttributeToSearchQuery(searchAttribute, searchQuery, logicalOperator),
        return_type: returnType,
        request_options: requestOptions
    };
}
function buildRequestFromCombinedSearchQuery(additionalSearchQuery, searchQuery, returnType, logicalOperator = SearchEnums_1.LogicalOperator.And, requestOptions) {
    return {
        query: combineSearchQuery(additionalSearchQuery, searchQuery),
        return_type: returnType,
        request_options: requestOptions
    };
}
function buildRequestFromSearchQuery(searchQuery, returnType, requestOptions) {
    return {
        query: searchQuery,
        return_type: returnType,
        request_options: requestOptions
    };
}
function addAttributeToSearchQuery(searchAttribute, searchQuery, logicalOperator = SearchEnums_1.LogicalOperator.And) {
    return combineSearchQuery(buildAttributeQuery(searchAttribute), searchQuery, logicalOperator);
}
function combineSearchQuery(additionalSearchQuery, searchQuery, logicalOperator = SearchEnums_1.LogicalOperator.And) {
    if (searchQuery.type === SearchEnums_1.Type.Group && searchQuery.logical_operator === logicalOperator) {
        const query = (0, lodash_1.cloneDeep)(searchQuery);
        query.nodes.push(additionalSearchQuery);
        return query;
    }
    return {
        type: SearchEnums_1.Type.Group,
        logical_operator: logicalOperator,
        nodes: [
            searchQuery,
            additionalSearchQuery
        ]
    };
}
function buildAttributeQuery(searchAttribute) {
    return {
        type: SearchEnums_1.Type.Terminal,
        service: searchAttribute.service,
        parameters: {
            attribute: searchAttribute.attribute,
            negation: typeof searchAttribute.negation === "boolean" ? searchAttribute.negation : false,
            operator: searchAttribute.operator,
            value: searchAttribute.value
        }
    };
}
function buildMultiFacet(addFacet, toFacet) {
    if (Array.isArray(toFacet.facets)) {
        toFacet.facets.forEach(f => buildMultiFacet(addFacet, f));
    }
    if ('name' in toFacet && 'attribute' in toFacet) {
        if (Array.isArray(toFacet.facets)) {
            toFacet.facets.unshift(addFacet);
        }
        else {
            toFacet.facets = [addFacet];
        }
    }
}
